import { createAuthRetryFetch } from "./authRetryFetch";

/** The parts of the token manager the tRPC fetch needs (web lib/tokenManager.ts). */
export interface TrpcFetchTokens {
    get(): string | null;
    waitForRefresh(): Promise<void>;
}

/**
 * The web app's tRPC fetch: re-sends a request once when a refresh replaced the token it
 * carried (PRTL-1519), and calls `onUnauthorized` (sign out, go to /login) for any 401 that
 * is left. Kept out of web's App.tsx so the whole decision, retry wrapper plus logout, is
 * tested with the token manager's real refresh tracking (server/src/utils/trpcFetch.test.ts).
 */
export function createTrpcFetch(deps: {
    fetch(url: string, init: RequestInit): Promise<Response>;
    tokens: TrpcFetchTokens;
    onUnauthorized(): void;
    waitTimeoutMs?: number;
}) {
    const fetchWithAuthRetry = createAuthRetryFetch({
        fetch: deps.fetch,
        getToken: () => deps.tokens.get(),
        waitForRefresh: () => deps.tokens.waitForRefresh(),
        waitTimeoutMs: deps.waitTimeoutMs,
    });
    return async (url: string, init: RequestInit): Promise<Response> => {
        const response = await fetchWithAuthRetry(url, init);
        if (response.status === 401) deps.onUnauthorized();
        return response;
    };
}
